import { useState } from "react"
import { getToken } from "../services/Token"
import Payroll from "./Payroll"
import PayRollTable from "./PayRollTable"
import PayrollSettings from "./PayrollSettings"
import AdminPayslips from "./AdminPayslips"
import { Box, Button } from "@mui/material"

const PayrollDashboard = ()=>{
    const roles = getToken("roles");
    const role = roles ? roles.includes("ADMIN") : false;
    const [selectedTab, setSelectedTab] = useState("payroll")
    const tabs = [
        {
          id: "payroll",
          name: "Payroll Process",
        },
        {
          id: "dashboard",
          name: "Dashboard",
        },
        {
          id: "settings",
          name: "Payroll Settings",
        },
        {
          id: "payslips",
          name: "Payslips",
        },
      ];

    const renderTab = () => {
      if (selectedTab === "payroll") return <Payroll />
      if (selectedTab === "dashboard") return <PayRollTable />
      if (selectedTab === "settings") return <PayrollSettings />
      if (selectedTab === "payslips") return <AdminPayslips />
      return null
    }

    return (
        <>
        {
            role && <Box className="flex justify-center" sx={{ pt: 6 }}>
            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              {tabs.map((tab) => (
                <Button
                  key={tab.id}
                  variant={selectedTab === tab?.id ? "contained" : "text"}
                  onClick={() => setSelectedTab(tab?.id)}
                  sx={{
                    textTransform: "none",
                    minWidth: 80,
                    backgroundColor:
                      selectedTab === tab?.id ? "#2196F3" : "transparent",
                    color: selectedTab === tab?.id ? "white" : "#666",
                    border: "1px solid #2196F3",
                  }}
                >
                  {tab?.name}
                </Button>
              ))}
            </Box>
          </Box>
        }
        { renderTab() }
        </>
    )
}

export default PayrollDashboard